module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Mail-notification-43e5dd9cb4fcdd3fe2439d5f6e748e35.svg";